<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li>
                        <li>Nama Medical Training Center</li>
                    </ul>
                </div>
            </section>
            <div class="mission_banner_wrapper full_banner_content">
                <div class="about_main_image">
                    <img src="../../assets/images/training-banner.jpg" alt="training-banner" />

                    <h5>NAMA MEDICAL TRAINING CENTER (NMTC):</h5>
                </div>
            </div>
            <div class="medical_for_network">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-10">
                            <div class="medical_inner_block mt-2 mb-4">
                                <div class="row">
                                    <div class="col-md-4 vertical-dashed-line">
                                        <div class="network_left_img">
                                            <img src="../../assets/images/for-individuals.png" alt="for-individuals" />
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <h5>For Individuals:</h5>
                                        <p>Choose from dynamic range of CPD programs that include lectures,
                                        informative tutorials, and workshops. Our scientific committee has
                                        large group of professors and consultants who review the content
                                        and objectives of every single CPD activity before approval to ensure
                                        it meets our internal quality-standards. On top of that, many Nama
                                        CPD programs are co-managed by one of our scientific partners.
                                        Scientific content and presentation are always prepared by best
                                        experts in the field.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="medical_inner_block mb-4">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="network_left_img">
                                            <img src="../../assets/images/image3.25b556f.png" alt="image3.25b556f" />

                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <h5>For Hospitals and Healthcare networks:</h5>
                                        <p>Workforce Evaluation Program (WEP) is new service for hospitals
                                        and healthcare networks aiming to improve the clinical
                                        workforce-performance and subsequently the clinical outcomes.
                                        Journey starts with comprehensive evaluation of knowledge and
                                        expertise among healthcare workers and according to
                                        client-specified requirements and types of clinical services; followed
                                        by didactic programs and workshops to fulfill the gaps, and ends by
                                        post-training evaluation. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fellowship_sec_wrap">
                <div class="fellowship_head">International Partners</div>
                <!--<div class="container">
                    <h3>1st time in SAUDI ARABIA</h3>
                </div>-->
            </div>
            <div class="fellowship_logo_wrap video-section">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-8">
                              <a href="https://isqua.org/education/middle-east-fellowship.html" target="_blank"><img src="../../assets/images/image6.png"></a>
                        </div>
                        <div class="col-md-4">
                            <div class="radar_video_block">
                            <!--<img src="../../assets/images/video-bg.png">
                              <div class="video_play_icon">
                                  <img src="../../assets/images/video-icon.png">
                              </div>
                            </div>-->

                            <iframe id="fellowship_logo_wrap_iframe" width="100%" height="196" src="https://www.youtube.com/embed/-hQICgXBA6Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                        </div>
                    </div>
                </div>
            </div>
            <div class="our_courses_wrap"   v-if="health_courses!=null && health_courses.length">
                <div class="container">
                    <h4 class="primary-color">Our courses and Programs</h4>
                    <div class="row">
                        <div class="col-md-6 program_block_wrap"   v-bind:class="{ disabled: isDisabledCourse(course.end_date) }"  v-for="course in health_courses">
                            <div class="row align-items-center">
                                <div class="col-md-4 col-4">
                                    <img :src="hostname+'/admin/images/course_images/'+course.image">
                                </div>
                                <div class="col-md-8 col-8">
                                    <div class="medical_right_sec">
                                        <h5>{{ course.name_eng }}</h5>
                                        <span>
                                            <i class="fas fa-calendar"></i>
                                            {{  format_date(course.start_date,course.end_date) }}
                                        </span>
                                        <router-link class="read_more" v-bind:to="'/courses/'+course.slug+'/'">Read More</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';

export default{
    data(){
        this.get_health_courses();
        this.get_nmtc_courses()
        return {
            health_courses:null,
            nmtc_courses:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale,
            slickOptions: {
                slidesToShow: 4,
                infinite: false,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            },
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        Slick:Slick
    },
    methods:{
        async get_health_courses() {
            var _self = this;
            await this.$axios_global.post(_self.$hostname+'/api/courses-by-category',{
                cat:'healthcare-quality',
                limit:-1
            })
            .then((res) => {
                var response = res.data.data;
                _self.health_courses = response;
            })
            .catch((error) => {
                return false;
            })
            return false;
        },
        isDisabledCourse(end_date){
            // console.log(end_date,"end_date",this.$moment_global().format('YYYY-MM-DD'),"current date" ,"current date");
            let A = this.$moment_global(end_date);
            let B = this.$moment_global();
            // console.log(A,"111111",B,"2222222222222")
            let diff = A.diff(B, 'days');// => 1
            // console.log(diff,"diff");
            return (diff < 0) ? true : false;
        },
        async get_nmtc_courses() {
            var _self = this;
            await this.$axios_global.post(_self.$hostname+'/api/courses-by-category',{
                cat:'medical-education-clinical-reasearch'
            })
            .then((res) => {
                var response = res.data.data;
                _self.nmtc_courses = response;
            })
            .catch((error) => {
                return false;
            })
            return false;
        },
        format_date(start,end){
            if (start && end) {
                var start_date_format =  this.$moment_global(String(start)).format('MMMM YYYY');
                var end_date_format   =  this.$moment_global(String(end)).format('MMMM YYYY');

                var start_year = this.$moment_global(String(start)).format('YYYY');
                var end_year = this.$moment_global(String(end)).format('YYYY');

                if(start_date_format == end_date_format){
                    var start_1 =  this.$moment_global(String(start)).format('Do');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return end_1;
                }
                else if(start_year == end_year){
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
                else{
                    var start_1 =  this.$moment_global(String(start)).format('Do MMMM YYYY');
                    var end_1   =  this.$moment_global(String(end)).format('Do MMMM YYYY');
                    return start_1 + ' - ' + end_1;
                }
            }
            return '';
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MedicalTrainingCenter.vue